export const getTreeMapSeries = (
  questionAnswers,
  crosstabRowTotals,
  grandTotal,
  forTreeMap
) => {
  let tempArray = [];

  for (let i = 0; i < questionAnswers.length; i++) {
    let questionAnswer = questionAnswers[i];
    let crossTabRowTotal = crosstabRowTotals[i];

    if (forTreeMap === "false") {
      if (crossTabRowTotal > 0) {
        let tempObject = {
          x: questionAnswer.desc,
          y: crossTabRowTotal,
        };
        tempArray.push(tempObject);
      }
    } else {
      let tempObject = {
        x: questionAnswer.desc,
        y: crossTabRowTotal,
      };
      tempArray.push(tempObject);
    }
  }

  let returnArray = tempArray.sort((a, b) => b.y - a.y);

  return [
    {
      data: returnArray,
    },
  ];
};
